import React from "react";
import { CheckCircle, AlertTriangle, ShieldCheck } from "lucide-react";

export default function Compliance() {
  return (
    <section className="py-20 bg-white px-4">
      <div className="max-w-6xl mx-auto">

        {/* ======================
            COMPLIANCE HEADER
        ====================== */}
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold mb-4">
            Safety, Compliance & Public Health Alignment
          </h2>
          <p className="text-gray-600 max-w-3xl mx-auto">
            AERZEN AIR™ is engineered with a clear understanding of India’s
            pollution realities, safety requirements, and evolving public
            health advisories.
          </p>
        </div>

        {/* ======================
            COMPLIANCE POINTS
        ====================== */}
        <div className="grid md:grid-cols-2 gap-6 text-left mb-14">
          {[
            "CE-compliant electrical and safety design architecture",
            "RoHS-aligned material selection for reduced toxic exposure",
            "HEPA filtration performance designed as per EN 1822 methodology",
            "Product design aligned with BIS electrical safety expectations for Indian homes",
          ].map((item, i) => (
            <div key={i} className="flex gap-3 items-start">
              <CheckCircle className="h-5 w-5 text-[var(--aerzen-blue)] mt-1" />
              <span className="text-sm">{item}</span>
            </div>
          ))}
        </div>

        {/* ======================
            GOVERNMENT ADVISORY BLOCK
        ====================== */}
        <div className="bg-[var(--aerzen-blue)]/5 border border-[var(--aerzen-blue)]/20 rounded-2xl p-8 mb-10">
          <div className="flex items-start gap-4">
            <AlertTriangle className="h-7 w-7 text-[var(--aerzen-blue)] mt-1" />

            <div>
              <h3 className="text-xl font-semibold mb-2">
                Air Quality Public Advisory
              </h3>

              <p className="text-sm text-gray-700 mb-4">
                During high pollution periods, Indian authorities such as
                CPCB, State Pollution Control Boards, and local administrations
                routinely issue advisories related to outdoor exposure,
                vehicular restrictions, and indoor air safety.
              </p>

              <ul className="text-sm text-gray-700 space-y-2">
                <li>• GRAP Stage advisories during severe AQI episodes</li>
                <li>• Temporary restrictions on older or high-emission vehicles</li>
                <li>• Health advisories for children, elderly, and respiratory patients</li>
                <li>• Recommendations to improve indoor air quality</li>
              </ul>
            </div>
          </div>
        </div>

        {/* ======================
            TRUST DISCLAIMER
        ====================== */}
        <div className="flex items-start gap-3 text-xs text-gray-500 max-w-4xl mx-auto">
          <ShieldCheck className="h-4 w-4 mt-0.5 text-gray-400" />
          <p>
            Advisory information shown on this platform is provided for public
            awareness only. AERZEN AIR™ does not represent any government body
            and does not issue enforcement directives. Users are encouraged to
            refer to official government notifications for formal instructions.
            Final certifications and compliance documents will be supplied with
            shipped products where applicable.
          </p>
        </div>

      </div>
    </section>
  );
}
